import _ from 'lodash';
import Vue from 'vue';
import Api from '../api/Api';
import {formatPercent} from "../utils/Format";

export default class BeerRecordValidator {

    /**
     *
     * @param record BeerRecord to be validated
     * @param all array All BeerRecords
     * @param categories array Available categories
     * @param additionalBeerCategoriesWithBeerType
     */
    constructor(record, all, categories, additionalBeerCategoriesWithBeerType) {
        this.errors = {};
        this.all = all;
        this.record = record;
        this.categories = categories;
        if(this.categories && this.record &&this.record.category)
        this.category = this.categories.find((category) => {
            return category.id === this.record.category;
        });
        this.additionalBeerCategoriesWithBeerType = additionalBeerCategoriesWithBeerType;
    }

    validateName() {
        this.flushError('name');

        if (!this.record.name) {
            this.errors.name = "page_setbeers.error.namemissing";
        }
    }

    validateQueryResponse() {
        this.flushError('query_response');
        if (this.category.is_query && (!this.record.query_response || this.record.query_response ==='')) {            
            this.errors.query_response = "page_setbeers.error.answermissing";
        }
    }


    validateCategory() {
        this.flushError('category');

        if (typeof this.record.category === 'undefined' || this.record.category === "") {
            Vue.set(this.errors, 'category', "page_setbeers.error.categorymissing");
        }

        // Check if category is used more than once, and allow max 3 beers per category
        const categoryCount = this.all.reduce((count, otherRecord) => {
            return count + (otherRecord.category === this.record.category ? 1 : 0);
        }, 0);
        if (categoryCount > 3) {
            Vue.set(this.errors, 'category', "page_setbeers.error.categoryusedmorethanthree");
        }

        this.category = this.categories.find((category) => {
            return category.id === this.record.category
        });

        if (this.record.alcVol) this.validateAlcVol();
        if (this.record.wortVol) this.validateWortVol();
        if (this.record.barrelPrevContent || this.record.barrelPrevContentText) this.validateBarrelPrevContent();
    }

    validateAlcVol() {
        this.flushError('alcVol');
        var alcVol = _.toNumber(this.record.alcVol);
        var alcMin = 0.1;
        var alcMax = 100;
        if(_.isNaN(alcVol)) {
            alcMin = this.category ? _.toNumber(this.category.alc_min) : 0.1;
            alcMax = this.category ? _.toNumber(this.category.alc_max) : 100;

            Vue.set(this.errors, 'alcVol',
                {msg: 'page_setbeers.error.alcvolmax', opt: [alcMin, alcMax]});
        }
        else if (this.record.category) {
            alcMin = _.toNumber(this.category.alc_min);
            alcMax = _.toNumber(this.category.alc_max);

            if (alcVol < alcMin || alcVol > alcMax) {
                Vue.set(this.errors, 'alcVol',
                    {msg: 'page_setbeers.error.alcvolmax', opt: [alcMin, alcMax]});
            }
        }
    }

    validateWortVol() {
        this.flushError('wortVol');
        var wortVol = _.toNumber(this.record.wortVol);
        var wortMin = 0.1;
        var wortMax = 100;
        if(_.isNaN(wortVol)) {
            wortMin = this.category ? _.toNumber(this.category.wort_min) : 0.1;
            wortMax = this.category ? _.toNumber(this.category.wort_max) : 100;

            Vue.set(this.errors, 'wortVol',
                {msg: 'page_setbeers.error.wortvolmax', opt: [wortMin, wortMax]});
        }
        if (this.record.category) {
            wortMin = _.toNumber(this.category.wort_min);
            wortMax = _.toNumber(this.category.wort_max);

            if (wortVol < wortMin || wortVol > wortMax) {
                Vue.set(this.errors, 'wortVol',
                    {msg: 'page_setbeers.error.wortvolmax', opt: [formatPercent(wortMin), formatPercent(wortMax)]});
            }
        }
    }



    flushError(name) {
        Vue.set(this.errors, name, "");
    }

    validateAll() {
        this.category = this.categories.find((category) => {
            return category.id === this.record.category
        });

        this.validateName();
        this.validateCategory();
        this.validateAlcVol();
        this.validateWortVol();
        this.validateQueryResponse();
    }

    validateBeerName(names, company){
        let dupes =  Api.post(`registrations/validatebeers/${(new Date().getFullYear())}`, {names: names, company:company});
        return dupes;
    }
}